export function setCookie(
  cname: string,
  cvalue: string,
  exdays: number = 1000
) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export function getCookie(cname: string) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const cookies = [
  'functional-cookies',
  'analytical-cookies',
  'video-cookies',
  'tracking-cookies',
  'readspeaker-cookies',
] as const

export type Cookie = typeof cookies[number]

export const requiredCookies: Cookie[] = ['functional-cookies', 'analytical-cookies']

export type Accepted = 'yes' | 'no'

export type Cookies = Map<Cookie, Accepted>
